import {DICT_KEY, getModel, setModel} from "../../../utils/constants";
import CustomerBillService from "./CustomerBillService";
import CustomerService from "../../base/customer/CustomerService"
import ModelUtils from "../../../utils/ModelUtils";

const MODEL_KEY = DICT_KEY.BILL_CUSTOMER;
const storageModel = getModel(MODEL_KEY);
const cacheAble = false;

const initState = {
    SearchParams: {},
    CustomerList: [],
    PageInfo: {
        // pageNum:1,
        // total:1
    },
    CustomerTotal: {
        // usedCreditLineTotal:0,
        // availableCreditTotal:0,
        // remainingAmountTotal:0
    },
    selectedCustomerRow: null,
    selectedCustomeRowKeys: [],
    ModelVisible: false,
    ModelParams: {
        title: "",
        Visible: false,
        type: ""
    },
    tabsKey: "account",
    tabsList: [],
    tabParams: null,
    tabPage: {},

    BillParams: {},//账单参数
    BillModelType: false,
    BillTable: [],
    BillTableKey: [],
    BillList: [],
    BillPage: {},
    accountList: [],
    accountTotal: {},
    accountRow: null,

    accountRowKeys: [],
    rechargeStatistics: {
        omitAmountTotal: 0.00,
        rechargeAmountTotal: 0.00,
    }
}
const customerBillModel = {
    state: cacheAble && storageModel ? storageModel : initState,
    reducers: {
        init(state,) {
            state.accountRow = null;
            state.accountRowKeys = [];
        },
        setRechargeStatistics(state, payload) {
            state.rechargeStatistics = payload;
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setSearchParams(state, payload) {
            state.SearchParams = {...payload}
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setCustomerList(state, payload) {
            state.CustomerList = payload
            setModel(MODEL_KEY, {...state});
            if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setPageInfo(state, payload) {
            state.PageInfo = payload
            setModel(MODEL_KEY, {...state})
        },
        setCustomerTotal(state, payload) {
            state.CustomerTotal = payload
            setModel(MODEL_KEY, {...state})
        },
        setSelectedCustomerRow(state, payload) {
            state.selectedCustomerRow = payload;
            setModel(MODEL_KEY, {...state})

        },
        setSelectedCustomeRowKeys(state, payload) {
            state.selectedCustomeRowKeys = payload;
            setModel(MODEL_KEY, {...state})
        },
        setModelVisible(state, payload) {
            state.ModelVisible = payload;
            setModel(MODEL_KEY, {...state})
        },
        setModelParams(state, payload) {
            state.ModelParams = {...state.ModelParams, ...payload};
            setModel(MODEL_KEY, {...state})
        },
        setTabType(state, payload) {
            state.TabType = payload
            setModel(MODEL_KEY, {...state})
        },
        /*setTabParams(state,payload){
            if(Object.keys(payload).length!=0){
                state.TabParams = {...state.TabParams,...payload}
            }else{
                state.TabParams = {...payload}
            }
            setModel(MODEL_KEY,{...state})
        },*/
        setBillParams(state, payload) {
            // if(Object.keys(payload).length!=0){
            //     console.log("走这里吗")
            //     state.BillParams = {...state.BillParams,...payload}
            // }else{
            state.BillParams = {...payload}
            // }
            // console.log(state.BillParams)
            setModel(MODEL_KEY, {...state})
        },
        setBillModelType(state, payload) {
            state.BillModelType = payload
            setModel(MODEL_KEY, {...state})
        },
        setBillTable(state, payload) {
            state.BillTable = payload
            setModel(MODEL_KEY, {...state})
        },
        setBillTableKey(state, payload) {
            state.BillTableKey = payload
            setModel(MODEL_KEY, {...state})
        },
        setBillList(state, payload) {
            state.BillList = payload
            setModel(MODEL_KEY, {...state})
        },
        setBillPage(state, payload) {
            state.BillPage = payload
            setModel(MODEL_KEY, {...state})
        },
        setAccountList(state, payload) {
            state.accountList = payload
            setModel(MODEL_KEY, {...state})
        },
        setAccountTotal(state, payload) {
            state.accountTotal = payload
            setModel(MODEL_KEY, {...state})
        },
        setAccountRow(state, payload) {
            state.accountRow = payload
            setModel(MODEL_KEY, {...state})
        },
        setAccountRowKeys(state, payload) {
            state.accountRowKeys = payload
            setModel(MODEL_KEY, {...state})
        },
        setTabsKey(state, payload) {
            state.tabsKey = payload;
            // setModel(MODEL_KEY, {...state});
        },
        setTabsList(state, payload) {
            state.tabsList = payload;
            setModel(MODEL_KEY, {...state});
        },
        setTabParams(state, payload) {
            state.tabParams = payload;
            // setModel(MODEL_KEY, {...state});
        },
        setTabPage(state, payload) {
            state.tabPage = payload;
        }

    },
    effects: () => ({
        async loadCustomerList({showMsg = true, duration = 5, data}) {
            const funName = "加载客户";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            data.pageSize = data.pageSize ? data.pageSize : 15
            data.pageNum = data.pageNum ? data.pageNum : 1
            const func = async () => {
                let retData = await CustomerBillService.findPage(data);

                const {info, statistic} = retData[0];
                const {list, ...page} = info
                list.forEach((el, index) => el.key = el.id);
                this.setCustomerList(list);
                this.setCustomerTotal(statistic);
                this.setPageInfo(page);
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async loadAccountList({showMsg = true, duration = 5, data}) {
            const funName = "加载客户账户信息";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await CustomerService.findAccountAll(data);
                const {list, statistic} = retData[0];
                list.forEach(el => el.key = el.id);
                this.setAccountList(list);
                this.setAccountTotal(statistic);
                // this.setPageInfo(page);
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async enableOrDisableAccount({showMsg = true, duration = 5, data}, {customerBill}) {
            const funName = "更新客户账户状态";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const {id, accountStatus} = data;
            // console.log(accountCode,checked)
            // let code = record.accountCode;
            // let checkeds = checked?0:1
            // return console.log(data)
            //调用接口
            const func = async () => {
                let retData = await CustomerService.accountEnableOrDisable(data);
                //更新本地数据
                const {accountList} = customerBill;
                const mapAccList = accountList.map(el => {
                    if (el.id === id) {
                        return {...el, accountStatus: accountStatus ? 1 : 0}
                    }
                    return el;
                });
                this.setAccountList(mapAccList);
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);

        },
        async adjustAccount({showMsg = true, duration = 5, datas}, {customerBill}) {
            const funName = "调整授信额度";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await CustomerService.adjustAccount(datas);
                //重新加载客户账户
                const {selectedCustomerRow} = customerBill;
                await this.loadAccountList({showMsg: false, data: selectedCustomerRow.id});
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async fillAccount({showMsg = true, duration = 5, data}, {customerBill}) {
            const funName = "账户充值";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await CustomerService.fillAccount(data);

                //重新加载客户账户
                const {selectedCustomerRow} = customerBill;
                await this.loadAccountList({showMsg: false, data: selectedCustomerRow.id});
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async transferAccount({showMsg = true, duration = 5, data}, {customerBill}) {
            const funName = "账户转账";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await CustomerService.transferAccount(data);

                //重新加载客户账户
                const {selectedCustomerRow} = customerBill;
                await this.loadAccountList({showMsg: false, data: selectedCustomerRow.id});
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async SupplierResizeLimitList({showMsg = true, duration = 5, data}, {customer}) {
            const funName = "调额记录";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            // return console.log(data)
            const func = async () => {
                let retData = await CustomerService.SupplierResizeLimitList(data);
                //重新加载客户账户
                let {list, ...page} = retData
                // console.log(retData)
                list.forEach(el => el.key = el.id);
                this.setTabsList(list);
                this.setTabPage(page)
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //加载转账记录
        async SupplierTransferAccountsList({showMsg = true, duration = 5, data}, {customer}) {
            const funName = "加载转账记录";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            // return console.log(data)
            const func = async () => {
                let retData = await CustomerService.SupplierTransferAccountsList(data);
                //重新加载客户账户
                let {list, ...page} = retData
                // console.log(retData)
                list.forEach(el => el.key = el.id);
                this.setTabsList(list);
                this.setTabPage(page)
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //加载充值记录
        async SupplierRechargeList({showMsg = true, duration = 5, data}, {customer}) {
            const funName = "充值记录";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            // return console.log(data)
            const func = async () => {
                let retData = await CustomerService.SupplierRechargeList(data);
                //重新加载客户账户
                let {list, statistics, ...page} = retData
                // console.log(retData)
                list.forEach(el => el.key = el.id);
                this.setTabPage(page)
                this.setTabsList(list);
                // console.log(statistics);
                this.setRechargeStatistics(statistics);
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //加载账单记录
        async loadBillList({showMsg = true, duration = 5, data}, {customerBill}) {
            const funName = "加载账单记录";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            // return console.log(data)
            data.pageSize = data.pageSize || 15;
            data.pageNum = data.pageNum || 1
            const func = async () => {
                let retData = await CustomerBillService.loadBillList(data);
                //重新加载客户账户
                let {list, ...page} = retData
                list.forEach(el => el.key = el.id);
                this.setBillList(list);
                this.setBillPage(page)
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //账单平账
        async BillFlat({showMsg = true, duration = 5, data}, {customerBill}) {
            const funName = "账单平账";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            // return console.log(data)
            const func = async () => {
                let retData = await CustomerBillService.BillFlat(data);
                const {selectedCustomerRow} = customerBill
                this.loadBillList({showMsg: false, data: {relationId: selectedCustomerRow.id}})

                //重新加载客户账户
                // let {list,...page} = retData
                // console.log(list,page)
                // list.forEach(el => el.key = el.id);
                // this.setBillList(list);
                // this.setBillPage(page)
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
    })
}


export default customerBillModel;